import { cn } from '@/lib/utils';

type SmsDisclosureProps = {
  notice: Diagonal.Auth.Data.SmsConsentNoticeData;
  className?: string;
};

/**
 * The carrier disclosure that must appear wherever a verification code is requested
 * by SMS, with links to the SMS Terms and the Privacy Policy.
 */
export function SmsDisclosure({ notice, className }: SmsDisclosureProps) {
  return (
    <p className={cn('text-xs text-muted-foreground', className)}>
      Standard message and data rates may apply. Reply STOP to stop messages. Read the{' '}
      <a href={notice.terms_url} target="_blank" rel="noreferrer" className="underline">
        SMS Terms and Conditions
      </a>{' '}
      and the{' '}
      <a href={notice.privacy_url} target="_blank" rel="noreferrer" className="underline">
        Privacy Policy
      </a>
      .
    </p>
  );
}
